var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _rect, _linearGradient4, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _linearGradient8, _path7, _linearGradient9, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bNooXHdAzjhP58BMwlrJca",
    x1: 24.709,
    x2: 23.584,
    y1: 23.336,
    y2: 45.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224759"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bNooXHdAzjhP58BMwlrJca)",
    d: "M15,41h15.528c1.515,0,2.9-0.856,3.578-2.211L35,37H13L15,41z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bNooXHdAzjhP58BMwlrJcb",
    x1: 50.995,
    x2: 29.732,
    y1: 10.04,
    y2: 36.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#f2efdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#c3d7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#a0c6b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#8cbcad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#84b8aa"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bNooXHdAzjhP58BMwlrJcb)",
    d: "M40,41h-5V13h2c1.657,0,3,1.343,3,3V41z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bNooXHdAzjhP58BMwlrJcc",
    x1: 33.005,
    x2: 11.793,
    y1: 0.612,
    y2: 58.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#f2efdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#c3d7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#a0c6b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#8cbcad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#84b8aa"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    x: 13,
    y: 13,
    fill: "url(#bNooXHdAzjhP58BMwlrJcc)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bNooXHdAzjhP58BMwlrJcd",
    x1: 30.115,
    x2: 19.688,
    y1: -4.549,
    y2: 23.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224759"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bNooXHdAzjhP58BMwlrJcd)",
    d: "M24,2c-6.075,0-11,4.925-11,11h22C35,6.925,30.075,2,24,2z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bNooXHdAzjhP58BMwlrJce",
    x1: 41.05,
    x2: 35.884,
    y1: 37.013,
    y2: 50.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#faf3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f2efdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#c3d7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#a0c6b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#8cbcad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#84b8aa"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bNooXHdAzjhP58BMwlrJce)",
    d: "M35,41v3c0,1.105,0.895,2,2,2h5c0-3,0-4-2-5H35z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bNooXHdAzjhP58BMwlrJcf",
    x1: 881.972,
    x2: 876.806,
    y1: 37.21,
    y2: 50.355,
    gradientTransform: "matrix(-1 0 0 1 889 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#faf3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#f2efdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#c3d7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#a0c6b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#8cbcad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#84b8aa"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bNooXHdAzjhP58BMwlrJcf)",
    d: "M13,41v3c0,1.105-0.895,2-2,2H6c0-3,0-4,2-5H13z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bNooXHdAzjhP58BMwlrJcg",
    x1: 890.736,
    x2: 869.834,
    y1: 11.281,
    y2: 38.133,
    gradientTransform: "matrix(-1 0 0 1 889 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#f2efdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#c3d7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#a0c6b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#8cbcad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#84b8aa"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bNooXHdAzjhP58BMwlrJcg)",
    d: "M8,41h5V13h-2c-1.657,0-3,1.343-3,3V41z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bNooXHdAzjhP58BMwlrJch",
    x1: 25.297,
    x2: 23.355,
    y1: 8.063,
    y2: 23.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224759"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bNooXHdAzjhP58BMwlrJch)",
    d: "M32,20H18c-1.105,0-2-0.895-2-2v-1h14c1.105,0,2,0.895,2,2V20z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bNooXHdAzjhP58BMwlrJci",
    x1: 27.444,
    x2: 22.647,
    y1: -1.827,
    y2: 11.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224759"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 7.5,
    r: 2.5,
    fill: "url(#bNooXHdAzjhP58BMwlrJci)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriod);
export default __webpack_public_path__ + "static/media/driod.9676729e8b27d7a547ee818cb47d26dc.svg";
export { ForwardRef as ReactComponent };